import {
  changeStateReducer,
  commonReducer,
  dataScope3Reducer,
  loaderReducer,
  premiumReducer,
} from './common'
import companyReducer from './company'
import dashboardReducer from './dashboard'
import emissionReducer from './emission'
import goalReducer from './goal'
import notificationReducer from './notification'
import tutorialReducer from './tutorial'
import { type AnyAction, combineReducers, type Reducer } from 'redux'
import { LOGOUT } from 'redux/action/type'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['toast', 'loaderState'],
}

const rootReducers = combineReducers({
  changeState: changeStateReducer,
  loaderState: loaderReducer,
  common: commonReducer,
  dataScope3: dataScope3Reducer,
  tutorial: tutorialReducer,
  dashboard: dashboardReducer,
  premium: premiumReducer,
  notification: notificationReducer,
  company: companyReducer,
  goal: goalReducer,
  emission: emissionReducer,
})

const appReducer: Reducer<ReturnType<typeof rootReducers>, AnyAction> = (
  state,
  action,
) => {
  if (action.type === LOGOUT) {
    state = undefined
  }
  return rootReducers(state, action)
}

const persistedReducer = persistReducer(persistConfig, appReducer)

export default persistedReducer
